import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "src/app/modules/auth";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class RolesService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  private auth = this.authService.getAuthFromLocalStorage();
  getRoles() {
    const ENDPOINT = `admin/area/lists/roles`;
    return this.http
      .get(`${environment.apiUrl}/${ENDPOINT}`)
      .pipe(map((res: any) => res.items));
  }

  getPermission() {
    const ENDPOINT = `admin/area/lists/permissions`;
    return this.http
      .get(`${environment.apiUrl}/${ENDPOINT}`)
      .pipe(map((res: any) => {
        if(res.items?.الاعدادات["اعدادات حوسبة "]){
          res.items.الاعدادات["اعدادات حوسبة"] = {
            Hawsabah : res.items.الاعدادات["اعدادات حوسبة "]
          }
          delete res.items.الاعدادات["اعدادات حوسبة "]
        }
        return res.items
      }));
  }

  getPermissionByOne(role_id) {
    const ENDPOINT = `admin/area/admin-roles/${role_id}/find`;
    return this.http
      .get(`${environment.apiUrl}/${ENDPOINT}`)
      .pipe(map((res: any) => res.item));
  }

  updatePermission(role_id,permission){
    const body = {
      "permission":permission
    }
    const ENDPOINT = `admin/area/admin-roles/${role_id}/update-row`;
    return this.http.put(`${environment.apiUrl}/${ENDPOINT}`, body)
  }

  SetUserPermission(permission){
    localStorage.setItem('userPermission',JSON.stringify(permission))
  }

}
